/* ----------------- UI Imports --------------- */
import BottomFab from "@memorang/ui/components/BottomFab";
import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";

/* ----------------- Component Imports --------------- */
import BrowseArticlesView from "./BrowseArticlesView";

/* ----------------- Types Imports --------------- */
import type { QuickActionsChipType } from "components/QuickActionChips/types";
import type { SectionListCardsType } from "types/image-challenge";

interface Props {
	quickActionsChips: QuickActionsChipType[];
	handleQuickActionPress: (action?: string) => void;
	issuesCollectionSectionListData: SectionListCardsType[];
	handleNavigateToAssistant: () => void;
}
const LatestIssuesCollectionView = ({
	issuesCollectionSectionListData,
	handleNavigateToAssistant,
}: Props) => {
	return (
		<>
			<ScrollContainer>
				<Box paddingTop={8} paddingBottom={8}>
					<BrowseArticlesView
						sectionListCardsData={issuesCollectionSectionListData}
					/>
				</Box>
			</ScrollContainer>
			<BottomFab
				icon="chat-question-outline"
				label="First Assist"
				onPress={handleNavigateToAssistant}
			/>
		</>
	);
};
export default LatestIssuesCollectionView;
